import { Flex, Text, Box } from '@cad-arc';
import React from 'react';
import { colors } from '../../colors/colors';

function ValidationError(props: { message: string }): React.ReactElement {
    return (
        <Flex position="absolute" bottom="69px" w="100%" justifyContent="center">
            <Box
                bg="negative.default"
                w="50%"
                border="md"
                borderColor={colors.commandLineValidationErrorBorder}
                borderRadius="3px"
                px="4"
            >
                <Text
                    style={{
                        fontSize: '16px',
                        fontFamily: 'roboto-mono',
                        color: 'var(--arc-colors-negative-content)',
                    }}
                >
                    {props.message}
                </Text>
            </Box>
        </Flex>
    );
}

export default ValidationError;
